import API from "../../../app/api";

export const getproductlist = async (slug, filters = {}) => {
  if (!slug) {
    throw new Error("Slug is required to fetch product list.");
  }

  const params = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (value == null) return;

    if (Array.isArray(value)) {
      if (value.length) {
        params[key] = value.join(",");
      }
    } else if (
      typeof value === "object" &&
      ("min" in value || "max" in value)
    ) {
      if (value.min != null) params.min = value.min;
      if (value.max != null) params.max = value.max;
    } else {
      params[key] = value;
    }
  });

  const endpoint =
    slug === "coming-soon"
      ? "/qualities/coming-soon/collection"
      : `/qualities/${slug}`;

  const response = await API.get(endpoint, {
    params,
  });

  return response.data.data;
};
